const AVATAR_COLORS = [
  'bg-rose-500/20 text-rose-400',
  'bg-orange-500/20 text-orange-400',
  'bg-amber-500/20 text-amber-400',
  'bg-emerald-500/20 text-emerald-400',
  'bg-teal-500/20 text-teal-400',
  'bg-cyan-500/20 text-cyan-400',
  'bg-blue-500/20 text-blue-400',
  'bg-indigo-500/20 text-indigo-400',
  'bg-violet-500/20 text-violet-400',
  'bg-fuchsia-500/20 text-fuchsia-400',
  'bg-pink-500/20 text-pink-400',
];

// Deterministic per-person color so the same teammate gets the same
// initials-avatar color everywhere (Team Chat, My Profile, HR table)
// without persisting one anywhere.
export function avatarColorClasses(seed) {
  const str = seed || '';
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}
